(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if(!customElements.get('nq-sticky-buy'))customElements.define('nq-sticky-buy',class extends HTMLElement{
connectedCallback(){this.source=document.getElementById(this.dataset.target);this.button=this.querySelector('button');if(!this.source||!this.button)return;this.sync=()=>{const b=this.source.querySelector('product-form button[name="add"]');const price=this.source.querySelector('[id^="price-"] .price');this.original=b;this.button.disabled=!b||b.disabled||b.getAttribute('aria-disabled')==='true';this.button.textContent=b?.querySelector('span')?.textContent.trim()||b?.textContent.trim()||'';const shown=price?.classList.contains('price--on-sale')?price?.querySelector('.price__sale .price-item--sale'):price?.querySelector('.price__regular .price-item--regular');this.querySelector('.nq-sticky-price').textContent=shown?.textContent.trim()||'';this.updateVisibility();};this.updateVisibility=()=>{const top=this.original?.getBoundingClientRect().bottom;this.classList.toggle('is-visible',typeof top==='number'&&top<0);};this.handleClick=()=>{if(this.original&&!this.button.disabled){this.original.click();this.source.querySelector('.product-form__error-message-wrapper')?.scrollIntoView({block:'nearest'});}};this.button.addEventListener('click',this.handleClick);this.observer=new MutationObserver(this.sync);this.observer.observe(this.source,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled','class']});window.addEventListener('scroll',this.updateVisibility,{passive:true});this.sync();}
disconnectedCallback(){this.observer?.disconnect();window.removeEventListener('scroll',this.updateVisibility);this.button?.removeEventListener('click',this.handleClick);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nq-feature"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const link=event.target.closest('[data-nq-buy-link]');if(!link)return;const target=document.querySelector('product-info[id^="MainProduct-"]');if(target){event.preventDefault();target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});const control=target.querySelector('variant-selects input, variant-selects select, button[name="add"]');if(control)control.focus({preventScroll:true});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nq-pdp-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const link=event.target.closest('[data-nqp-buy]');if(!link)return;const target=document.querySelector('product-info[id^="MainProduct-"] .product__info-container');if(!target)return;event.preventDefault();target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});const control=target.querySelector('variant-selects input,variant-selects select,button[name="add"]');control?.focus({preventScroll:true});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nqc-youll-also-love"] && !Shopify.designMode) return;
  try {
    
function initLove(root=document){root.querySelectorAll('.nqc-cross-sell').forEach(section=>{if(section.dataset.carouselReady)return;section.dataset.carouselReady='true';const track=section.querySelector('.nqc-love-track'),prev=section.querySelector('[data-love-prev]'),next=section.querySelector('[data-love-next]');if(!track||!prev||!next)return;const update=()=>{prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2};const move=d=>track.scrollBy({left:d*(track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(track);update()})}initLove();document.addEventListener('shopify:section:load',e=>initLove(e.target));

  } catch(e) { console.error(e); }
})();
})();
